import {
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_FILL_IN_BLANKS_RESPONSE,
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_MULTIPLE_CHOICE,
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_DRAW,
  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE_CATEGORISE,
  ACTIVITIES_COMPONENT_TYPE_TABLE,
} from 'global/constants';
import { ComponentDraw } from './components/component.constants';
import { ComponentInteractiveResponseCategorise } from './components/component.constants';
import { ComponentInteractiveResponseSequence } from './components/component.constants';
import { ComponentMultipleChoice } from './components/component.constants';
import { ComponentTable } from './components/component.constants';
import { ComponentResponse } from './components/component.constants';

export type AnswerComponent =
  | ComponentResponse
  | ComponentTable
  | ComponentMultipleChoice
  | ComponentInteractiveResponseSequence
  | ComponentInteractiveResponseCategorise
  | ComponentDraw;

export const AnswerComponents = [
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_TABLE,
  ACTIVITIES_COMPONENT_TYPE_DRAW,
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_MULTIPLE_CHOICE,
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_FILL_IN_BLANKS_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE_CATEGORISE,
];
